import fetch from 'isomorphic-fetch';
import { API } from '../../config';

export const editEmployeeProfile = async (data, id) => {
  console.log('INI data', data);
  try {
    const response = await fetch(`${API}/employee/update/${id}`, {
      method: 'PATCH',

      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },

      body: { data },
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};
